import { useEffect, useState, useCallback } from 'react'

import { FeedbackTable } from '../../Components/Feedbacks/feedbackTable'

import Feedback from '../../API/Employee/Feedback'
import Loading from '../../Components/Loading/Loading'

import { Select } from '../../Components/Employee/Select/Select'
import employeeFeedbackMapper from '../../Utils/EmployeeFeedbackMapper.js'

import Swal from 'sweetalert2'

export function Feedbacks() {
	const [data, setData] = useState([])
	const [list, setList] = useState(null)
	const [selected, setSelected] = useState(null)
	const [loadingData, setLoadingData] = useState(false)

	const loadData = useCallback(async () => {
		try {
			const { id } = JSON.parse(localStorage.getItem('user'))
			const response = await Feedback.getAllEmployeeWithFeedbacksSender(id)
			setList(response.map(employeeFeedbackMapper.toDomain))
		} catch {
			Swal.fire({
				icon: 'error',
				title: 'Oops...',
				text: 'Algo salió mal !',
			})
		}
	}, [])

	useEffect(() => {
		loadData()
	}, [loadData])

	const handleSelect = async event => {
		try {
			setLoadingData(true)
			setSelected(event.target)
			const { data } = await Feedback.getAllSendFeedbacks(event.target.value)
			setData(data)
		} catch {
			Swal.fire({
				icon: 'error',
				title: 'Oops...',
				text: 'Algo salió mal !',
			})
		} finally {
			setLoadingData(false)
		}
	}

	if (!list) return <Loading />

	return (
		<div className='tw-pr-8'>
			<h1 className='tw-text-2xl tw-font-bold tw-mb-4'>Feedbacks Enviados</h1>
			<div className='tw-mt-5'>
				<Select placeholder='Colaborador' list={list} onChange={handleSelect} name='employee' value={selected?.value} />
			</div>
			<div className='tw-mt-5 '>
				{loadingData && (
					<div>
						<Loading />
					</div>
				)}
				{!loadingData && (
					<>
						{data?.length === 0 ? (
							<div className='tw-flex tw-items-center tw-justify-center tw-flex-col tw-bg-gray-100 tw-p-4 tw-space-y-5 tw-h-[75vh]'>
								<div className='tw-font-bold tw-text-xl'>Seleccione un colaborador para ver sus feedbacks enviados.</div>
							</div>
						) : (
							<FeedbackTable data={data} />
						)}
					</>
				)}
			</div>
		</div>
	)
}
